/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { GetShowDebtorTokensQueryResponse, GetShowDebtorTokensPathParams, GetShowDebtorTokens400, GetShowDebtorTokens401 } from "../../models/GetShowDebtorTokens";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getGetShowDebtorTokensUrl({ debtorCode }: { debtorCode: GetShowDebtorTokensPathParams["debtorCode"] }) {
  const res = { method: 'GET', url: `/api/v1/debtors/${debtorCode}/tokens` as const }  
  return res
}

/**
 * {@link /api/v1/debtors/:debtorCode/tokens}
 */
export async function getShowDebtorTokens({ debtorCode }: { debtorCode: GetShowDebtorTokensPathParams["debtorCode"] }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetShowDebtorTokensQueryResponse, ResponseErrorConfig<GetShowDebtorTokens400 | GetShowDebtorTokens401>, unknown>({ method : "GET", url : getGetShowDebtorTokensUrl({ debtorCode }).url.toString(), ... requestConfig })  
  return res.data
}